import React from "react";
import { createPortal } from "react-dom";

const Loader = () => {
  return createPortal(
    <div
      className="loader-container"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        flexDirection: "column",
      }}
    >
      <img
        style={{ width: "60px", height: "60px" }}
        src="/assets/Loader.gif"
        alt="Loading..."
        onError={(e) => {
          // Fallback if image fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
          const parent = target.parentElement;
          if (parent) {
            parent.innerHTML =
              '<div style="color: white; font-size: 18px;">Loading...</div>';
          }
        }}
      />
    </div>,
    document.body
  );
};

export default Loader;
